<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">Egresos</h3>
        </b-card-header>
        <b-row>
            <b-col md="3" class="ml-4">
                <b-form-group label="Buscar" label-for="choferID">
                    <el-input v-model="search" placeholder="empresa, material..." />
                </b-form-group>
            </b-col>
            <b-col md="3" class="ml-4">
                <b-form-group label="Estado Pago" label-for="choferID">
                    <b-form-select id="estadopago-filter" v-model="filter.estadoPago" :options="estadoPagoOptions"
                        ></b-form-select>
                </b-form-group>
            </b-col>
            <!-- <b-col md="4">
                <b-form-group label="Estado" label-for="choferID">
                    <b-form-select id="estadopago-filter" v-model="filter.estadoEgreso" :options="estadoEgresoOptions"
                        required></b-form-select>
                </b-form-group>
            </b-col> -->
        </b-row>
        <b-row>
            <b-col md="4">
                <b-form-group class="ml-4">
                    <b-button type="submit" @click="getAllFiltered()" variant="primary">
                        Buscar
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
        <el-table class="table-responsive table" header-row-class-name="thead-light" :data="filterTableData">
            <el-table-column label="g_traslado" prop="budget" min-width="140px">
                <template v-slot="{ row }">
                    <span class="status">{{ row.guiaTraslado }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Patente" min-width="120px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.patente }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Empresa" min-width="200px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.empresa }}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="Material" min-width="250px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.material }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Fecha" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.fecha }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Peso" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.peso }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Precio Total" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.precio }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Estado pago" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.estadoPago }}</span>
                </template>
            </el-table-column>

            <el-table-column label="Acción" min-width="170px" prop="action">
                <template v-slot="{ row }">
                    <router-link :to="{ name: 'detalle', params: { id: row.id } }">
                        <b-button variant="primary" class="btn-create-new">
                            <i class="fas fa-eye"></i> Ver
                        </b-button>
                    </router-link>
                </template>
            </el-table-column>

        </el-table>
        <!-- 
        <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> 
        -->
    </b-card>
</template>
<script>
import egresoService from '@/api/egresoService';
import pagoService from '@/api/pagoService';
import { Table, TableColumn } from 'element-ui'
export default {
    name: 'egresos-table',
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            tableData: [],
            search: '',
            currentPage: 1,
            estadoPagoOptions: [],
            estadoEgresoOptions: [],
            filter: {
                estadoPago: 0,
                estadoEgreso: 0,
                grupoEstado: 0
            }
        };
    },
    computed: {
        filterTableData() {
            const searchTerm = this.search.toLowerCase(); // Convertir a minúsculas para comparación
            if(searchTerm == '') return this.tableData;
            return this.tableData.filter(item => item.material !=null && (
                item.material.toLowerCase().includes(searchTerm) || item.empresa.toLowerCase().includes(searchTerm))
            );
        }
    },
    async beforeMount() {
        try {
            const grupo = this.$route.params.grupo;
            this.filter.grupoEstado = grupo;
            this.estadoPagoOptions = await pagoService.getEstadosOptions();
            this.estadoEgresoOptions = await egresoService.getEstadosOptions();
            this.tableData = await egresoService.getAllFiltered(this.filter);
        } catch (error) {
            console.error('Error fetching Egresos:', error);
        }
    },
    methods: {
        async getAllFiltered() {
            try {
                if (this.filter.estadoPago > 0 || this.filter.estadoEgreso > 0) {
                    this.tableData = await egresoService.getAllFiltered(this.filter);
                } else {
                    alert(`El valor del filtro es: ${this.filter.estadoPago}`);
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        }
    }
}
</script>
